const isPremiseHealth = (organizationName?: string) => (
  organizationName?.toLowerCase() === "premise health"
);

export default isPremiseHealth;
